import ReactGA from 'react-ga4';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { LinearProgress } from '@mui/material';

import useAxios from 'src/hooks/use-axios';
import { useAuth } from 'src/hooks/use-auth';
import { useDoctor } from 'src/hooks/use-doctor';

function RequireAuth({ element }) {
  const id = element?.props.id;

  const { doctor, setDoctor } = useDoctor();
  const location = useLocation();
  const { auth } = useAuth();
  const api = useAxios();

  const demo_user = '/details/7242';

  const [isLoading, setIsLoading] = useState(true);
  const [firstVisit, setFirstVisit] = useState(false);

  useEffect(() => {
    const fetchUserProfile = async () => {
      let profile;
      try {
        profile = (await api.get('/v1/users/profile/')).data;

        if (profile.organization_id) {
          const organization = (await api.get(`/v1/organizations/${profile.organization_id}/`)).data;
          profile = { ...profile, organization };
        }
      } catch (err) {
        console.log(err);
      } finally {
        setDoctor(profile);
        setIsLoading(false);

        const returning_user = localStorage.getItem('returning_user');
        if (!returning_user) {
          setFirstVisit(true);
          localStorage.setItem('returning_user', 'true');
        }
      }
    };

    fetchUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasAccess = doctor?.access.includes(id);

  const redirectPath =
    location.pathname !== '/' ? `?next=${encodeURIComponent(location.pathname + location.search)}` : '';

  if (!auth) return <Navigate to={`/login/${redirectPath}`} state={{ from: location }} replace />;

  if (isLoading) return <LinearProgress sx={{ mx: { xs: '2vh', lg: 25 }, mt: { xs: '40vh', lg: 'auto' } }} />;

  if (doctor?.last_name?.toLowerCase() === 'demo') {
    if (location.pathname !== demo_user) return <Navigate to={demo_user} state={{ from: location }} replace />;
  }

  if (!hasAccess || !element) {
    let path = '/404';
    if (doctor?.access.includes('invites')) path = '/invites';
    if (doctor?.access.includes('patients')) path = '/patients';
    if (doctor?.access.includes('gp')) path = '/invites';
    if (doctor?.access.includes('screening')) path = '/screening';
    if (doctor?.access.includes('reviews')) path = '/reviews';
    if (doctor?.last_name?.toLowerCase() === 'demo') path = demo_user;
    if (doctor?.doula && firstVisit) path = '/demo';

    ReactGA.event({
      category: 'navigation',
      action: 'no_access',
      label: id,
      value: doctor?.id,
    });

    return <Navigate to={path} state={{ from: location }} replace />;
  }

  return element;
}

export default RequireAuth;

RequireAuth.propTypes = {
  element: PropTypes.element,
};
